module.exports = __webpack_public_path__ + "img/vi.d17ef74d.svg";